const extractUrl = (str) => {
  var regex = /(https?:\/\/(?:www\.|(?!www))([^\s.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
  return str.match(regex);
};

export default extractUrl;
